'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_UserProfilePage$State(mealoramaState, user, passwordPair, accountUsers, editUser, dlg, msgState, extensionToken, generatingToken) {
  this.kS = null;
  this.e1 = null;
  this.iM = null;
  this.kQ = null;
  this.k9 = null;
  this.mC = null;
  this.kT = null;
  this.kR = null;
  this.lq = false;
  this.kS = mealoramaState;
  this.e1 = user;
  this.iM = passwordPair;
  this.kQ = accountUsers;
  this.k9 = editUser;
  this.mC = dlg;
  this.kT = msgState;
  this.kR = extensionToken;
  this.lq = generatingToken;
}
export { $c_Lmealorama_pages_UserProfilePage$State as $c_Lmealorama_pages_UserProfilePage$State };
$p = $c_Lmealorama_pages_UserProfilePage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_UserProfilePage$State;
/** @constructor */
function $h_Lmealorama_pages_UserProfilePage$State() {
}
export { $h_Lmealorama_pages_UserProfilePage$State as $h_Lmealorama_pages_UserProfilePage$State };
$h_Lmealorama_pages_UserProfilePage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kS));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.e1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iM));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kQ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k9));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mC));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kT));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kR));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.lq ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 9);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_UserProfilePage$State)) {
    if ((this.lq === x$0.lq)) {
      var x = this.kS;
      var x$2 = x$0.kS;
      var $x_7 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.e1;
      var x$4 = x$0.e1;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.iM;
      var x$6 = x$0.iM;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.kQ;
      var x$8 = x$0.kQ;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.k9;
      var x$10 = x$0.k9;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.mC;
      var x$12 = x$0.mC;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.kT;
      var x$14 = x$0.kT;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.kR;
      var x$16 = x$0.kR;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 9;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.kS;
      break;
    }
    case 1: {
      return this.e1;
      break;
    }
    case 2: {
      return this.iM;
      break;
    }
    case 3: {
      return this.kQ;
      break;
    }
    case 4: {
      return this.k9;
      break;
    }
    case 5: {
      return this.mC;
      break;
    }
    case 6: {
      return this.kT;
      break;
    }
    case 7: {
      return this.kR;
      break;
    }
    case 8: {
      return this.lq;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_UserProfilePage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kK)));
}
export { $isArrayOf_Lmealorama_pages_UserProfilePage$State as $isArrayOf_Lmealorama_pages_UserProfilePage$State };
var $d_Lmealorama_pages_UserProfilePage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_UserProfilePage$State, "mealorama.pages.UserProfilePage$State", ({
  kK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_UserProfilePage$State as $d_Lmealorama_pages_UserProfilePage$State };
//# sourceMappingURL=mealorama.pages.-User-Profile-Page$-State.js.map
